import NavigationLayout from "../navigation/navigationLayout";
import FooterLayout from "../footer/footerLayout";
import ContactInfoLayout from "./contact/contactInfoLayout";
import LocationMap from "./locationMap";
import SocialMediaLayout from "./socialMedia/socialMediaLayout";
import FaqLayout from "./faq/faqLayout";
import { useEffect } from "react";
import PlatformLayout from "./platform/platformLayout";

const ContactUsLayout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <ContactInfoLayout />

            <LocationMap />

            <SocialMediaLayout />

            <PlatformLayout />

            <FaqLayout />

            <FooterLayout />
        </>
    );
}

export default ContactUsLayout;